module.exports = __webpack_public_path__ + "img/hiw_img02.e2234d2e.png";